import {
  type StorageLike,
  type UseStorageOptions,
  useStorage,
} from '@vueuse/core'
import type { AstroCookies } from 'astro'
import Cookies from 'js-cookie'

import { isSSR } from '@fond-of/env'

declare global {
  // eslint-disable-next-line
  var cookies: AstroCookies
}

const ssrCookieStorage: StorageLike = {
  getItem: (key: string) => {
    return globalThis.cookies.get(key)?.value ?? null
  },
  setItem: (key, value) => {
    return globalThis.cookies.set(key, value, {
      path: '/',
    })
  },
  removeItem: (key) => {
    return globalThis.cookies.delete(key)
  },
}

const clientCookieStorage: StorageLike = {
  getItem: (key: string) => {
    return Cookies.get(key) ?? null
  },
  setItem: (key, value) => {
    return Cookies.set(key, value, {
      path: '/',
    })
  },
  removeItem: (key) => {
    return Cookies.remove(key)
  },
}

const cookieStorage = isSSR() ? ssrCookieStorage : clientCookieStorage

export const useCookieStorage = <T>(
  key: string,
  defaultValue: T,
  options?: UseStorageOptions<T>
) => useStorage(key, defaultValue, cookieStorage, options)
